module.exports = __webpack_public_path__ + "img/melo-blue.0258d0a0.svg";